import { render } from "./NewsMainPage.vue?vue&type=template&id=33bbbff6&scoped=true"
import script from "./NewsMainPage.vue?vue&type=script&lang=js"
export * from "./NewsMainPage.vue?vue&type=script&lang=js"

import "./NewsMainPage.vue?vue&type=style&index=0&id=33bbbff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bbbff6"]])

export default __exports__